import React, { Component } from "react";

import PropTypes from "prop-types";
import { connect } from "react-redux";
import ProfileLink from "./container/ProfileLink";
import { Translation } from "./helper/transComp";

class FooterLoggedInOut extends Component {
  constructor(props) {
    super(props);
    this.state = {
      test: "kd",
    };
  }
  componentDidMount() {
    this.setState({ test: "kfdkfkf" }); //Don't delete we need to re render
  }

  componentDidUpdate() {
    // this.setState({ test: "lkdjf" });
  }

  static propTypes = {
    isAuthenticated: PropTypes.bool.isRequired,
    language: PropTypes.object.isRequired,
  };

  render() {
    return (
      <footer className="mainFooter">
        <div className="FooterQuart">
          <ProfileLink
            onClick={(e) => {
              this.setState({ isOpen: false });
            }}
            filter={this.props.isAuthenticated ? "/projects" : "/"}
          >
            <img
              src={`/../img/logo.webp`}
              alt={"logo"}
              className="FooterLogo"
            />
          </ProfileLink>
          <p className="devise">
            <Translation str={"FooterDevise"} />
          </p>
          <div>
            <img
              src="../../img/newphone.webp"
              style={{
                width: "20px",
                height: "20px",
                marginRight: "5px",
                alignSelf: "center",
              }}
              alt="logo téléphone"
            />
            <p style={{ margin: "0", alignSelf: "center" }}>
              0033 9 81 14 66 78
            </p>
          </div>
          <div>
            <img
              src="../../img/newemail.webp"
              alt="logo email"
              style={{
                width: "25px",
                height: "25px",
                marginRight: "5px",
                alignSelf: "center",
              }}
            />
            <p style={{ margin: "0", alignSelf: "center" }}>
              <a href="mailto:support@luckiwi.com" className="mailto">
                support@luckiwi.com
              </a>
            </p>
          </div>
          <p>227 Av. Jean Jaurès, Lyon FR</p>
          <div className="FooterSocial">
            <a
              href="https://www.linkedin.com/company/luckiwi/"
              aria-label="Linkedin LUCKiwi"
              target="blank"
            >
              <img
                src="../../img/linkedin.webp"
                alt="logo linkedin"
                style={{
                  width: "20px",
                  height: "20px",
                }}
              />
            </a>
            <a
              href="https://www.instagram.com/luckiwi_gestion_projets/"
              aria-label="Instagram LUCKiwi"
              target="blank"
            >
              <img
                src="../../img/insta.webp"
                alt="logo instagram"
                style={{
                  width: "20px",
                  height: "20px",
                }}
              />
            </a>
            <a
              href="https://www.youtube.com/@luckiwi6916"
              aria-label="Youtube LUCKiwi"
              target="blank"
            >
              <img
                src="../../img/youtube.webp"
                alt="logo youtube"
                style={{
                  width: "20px",
                  height: "20px",
                }}
              />
            </a>
          </div>
        </div>
        <div className="FooterQuart">
          <p className="FooterTitle">
            <Translation str={"FooterLog"} />
          </p>
          <ul>
            <li>
              <a
                href={`https://www.luckiwi.com/${this.props.language}/solutions`}
              >
                <Translation str={"FooterSolutions"} />{" "}
              </a>
            </li>
            {/* <li>
              <a href={`https://luckiwi.com/${this.props.language}/pricing`}>
                <Translation str={"HeaderPricing"} />
              </a>
            </li> */}
            <li>
              <a
                href={`https://app.luckiwi.com/${this.props.language}/register`}
              >
                <Translation str={"HeaderRegister"} />
              </a>
            </li>
          </ul>
        </div>
        <div className="FooterQuart">
          <p className="FooterTitle">
            <Translation str={"FooterSociete"} />
          </p>
          <ul>
            <li>
              <a href={`https://www.luckiwi.com/${this.props.language}/about`}>
                <Translation str={"FooterAbout Us"} />{" "}
              </a>
            </li>
            <li>
              <a
                href={`https://app.luckiwi.com/${this.props.language}/contact`}
              >
                <Translation str={"FooterContactUs"} />
              </a>
            </li>
            <li>
              <a href={`https://www.luckiwi.com/${this.props.language}/blog`}>
                <Translation str={"FooterBlog"} />
              </a>
            </li>
            <li>
              <a
                href={`https://www.luckiwi.com/${this.props.language}/collaboration`}
              >
                <Translation str={"FooterCollaboration"} />
              </a>
            </li>
          </ul>
        </div>
        <div className="FooterQuart">
          <p className="FooterTitle">
            <Translation str={"FooterInformations"} />
          </p>
          <ul>
            <li>
              <a
                href={`https://www.luckiwi.com/${this.props.language}/legalnotice`}
              >
                <Translation str={"FooterLegalNotice"} />{" "}
              </a>
            </li>
            <li>
              <a
                href={`https://www.luckiwi.com/${this.props.language}/privacy`}
              >
                <Translation str={"FooterPrivacy"} />
              </a>
            </li>
            <li>
              <a
                href={`https://www.luckiwi.com/${this.props.language}/termsofservice`}
              >
                <Translation str={"FooterTerms"} />
              </a>
            </li>
            <li>
              <a
                href={`https://www.luckiwi.com/${this.props.language}/cookies`}
              >
                <Translation str={"FooterCookies"} />
              </a>
            </li>
          </ul>
        </div>
        <div className="FooterResponsive">
          <ul>
            <li>
              <p className="FooterTitle">
                <Translation str={"FooterLog"} />
              </p>
            </li>
            <li>
              <a
                href={`https://www.luckiwi.com/${this.props.language}/solutions`}
              >
                <Translation str={"FooterSolutions"} />{" "}
              </a>
            </li>
            {/* <li>
              <a href={`https://www.luckiwi.com/${this.props.language}/outils`}>
                <Translation str={"FooterOutils"} />
              </a>
            </li> */}
            {/* <li>
              <a href={`https://luckiwi.com/${this.props.language}/pricing`}>
                <Translation str={"HeaderPricing"} />
              </a>
            </li> */}
            <li>
              <a
                href={`https://app.luckiwi.com/${this.props.language}/register`}
              >
                <Translation str={"HeaderRegister"} />
              </a>
            </li>
          </ul>
          <ul>
            <li>
              {" "}
              <p className="FooterTitle">
                <Translation str={"FooterSociete"} />
              </p>
            </li>
            <li>
              <a href={`https://www.luckiwi.com/${this.props.language}/about`}>
                <Translation str={"FooterAbout Us"} />{" "}
              </a>
            </li>
            <li>
              <a
                href={`https://app.luckiwi.com/${this.props.language}/contact`}
              >
                <Translation str={"FooterContactUs"} />
              </a>
            </li>
            <li>
              <a href={`https://www.luckiwi.com/${this.props.language}/blog`}>
                <Translation str={"FooterBlog"} />
              </a>
            </li>
            <li>
              <a
                href={`https://www.luckiwi.com/${this.props.language}/collaboration`}
              >
                <Translation str={"FooterCollaboration"} />
              </a>
            </li>
          </ul>
          <ul>
            <li>
              <p className="FooterTitle">
                <Translation str={"FooterInformations"} />
              </p>
            </li>
            <li>
              <a
                href={`https://www.luckiwi.com/${this.props.language}/legalnotice`}
              >
                <Translation str={"FooterLegalNotice"} />{" "}
              </a>
            </li>
            <li>
              <a
                href={`https://www.luckiwi.com/${this.props.language}/privacy`}
              >
                <Translation str={"FooterPrivacy"} />
              </a>
            </li>
            <li>
              <a
                href={`https://www.luckiwi.com/${this.props.language}/termsofservice`}
              >
                <Translation str={"FooterTerms"} />
              </a>
            </li>
            <li>
              <a
                href={`https://www.luckiwi.com/${this.props.language}/cookies`}
              >
                <Translation str={"FooterCookies"} />
              </a>
            </li>
          </ul>
        </div>
      </footer>
    );
  }
}

const mapStateToProps = (state) => ({
  isAuthenticated: state.auth.isAuthenticated,
  // this is props so add prop type
  language: state.user.language,
});

export default connect(mapStateToProps, {})(FooterLoggedInOut);
